// Code for Chatlio widget - do not edit.
'use client'

import Script from 'next/script'

declare global {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace JSX {
        interface IntrinsicElements {
            'chatlio-widget': any
        }
    }

    interface Window {
        _chatlio?: {
            identify: (userId: string, userData: Record<string, any>) => void
            show: (options?: { expanded?: boolean }) => void
        }
    }
}

// Function to identify users with Chatlio
export const identifyChatlio = (
    userId: string,
    userData: Record<string, any>,
) => {
    if (typeof window !== 'undefined' && window._chatlio) {
        window._chatlio.identify(userId, userData)
    } else {
        console.warn(
            'Chatlio not initialized yet. User identification will not work.',
        )
    }
}

export const ChatlioInit: React.FC = () => {
    return (
        <>
            <Script
                src="https://js.chatlio.com/widget.js"
                strategy="lazyOnload"
            />
            <chatlio-widget
                widgetid="febfd003-967c-4737-70b7-0c8c1ef6d30b"
                disable-favicon-badge
            ></chatlio-widget>
        </>
    )
}
